const groupInitiativesByLastWeekWeeklyStatus = (initiatives) => {
  const lastWeekWeeklyStatus = (initiatives) => {
    const now = new Date();
    const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

    return initiatives.map((init) => {
      let lastWeekWeeklyStatus = init.weeklyStatus;

      const relevantHistory = (init.history || [])
        .filter(
          (entry) =>
            entry &&
            entry.action &&
            entry.action.includes('the Weekly Status was change from') &&
            new Date(entry.timestamp) <= oneWeekAgo
        )
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      if (relevantHistory.length > 0) {
        const historyDate = new Date(relevantHistory[0].timestamp);
        if (historyDate <= oneWeekAgo) {
          lastWeekWeeklyStatus = relevantHistory[0].changes.previoousWeeklyStatus;
        } else {
          lastWeekWeeklyStatus = relevantHistory[0].changes.newValue;
        }
      } else if (new Date(init.created) <= oneWeekAgo) {
        lastWeekWeeklyStatus = init.weeklyStatus;
      } else {
        lastWeekWeeklyStatus = init.weeklyStatus;
      }

      return {
        ...init,
        lastWeekWeeklyStatus: lastWeekWeeklyStatus,
      };
    });
  };

  const initiativesWithLWStatus = lastWeekWeeklyStatus(initiatives);

  const rangeGroups = {
    '<not set>': [],
    'On track': [],
    'Some issues': [],
    'Leadership attention': [],
    'On hold': [],
    Cancelled: [],
    Rejected: [],
  };

  initiativesWithLWStatus.forEach((initiative) => {
    const lwStatus = initiative.lastWeekWeeklyStatus;

    if (lwStatus && lwStatus === 'On Track') {
      rangeGroups['On track'].push(initiative);
    } else if (lwStatus && lwStatus === 'Some Issues') {
      rangeGroups['Some issues'].push(initiative);
    } else if (lwStatus && lwStatus === 'On Hold') {
      rangeGroups['On hold'].push(initiative);
    } else if (lwStatus && lwStatus === 'Leadership Attention') {
      rangeGroups['Leadership attention'].push(initiative);
    } else if (lwStatus && lwStatus === 'Cancelled') {
      rangeGroups['Cancelled'].push(initiative);
    } else if (lwStatus && lwStatus === 'Rejected') {
      rangeGroups['Rejected'].push(initiative);
    } else {
      rangeGroups['<not set>'].push(initiative);
    }
  });

  return rangeGroups;
};
export default groupInitiativesByLastWeekWeeklyStatus;
